var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 97 102",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M48.527 15.865c1.096 0 1.985-.908 1.985-2.029 0-1.12-.889-2.03-1.985-2.03s-1.984.91-1.984 2.03c0 1.12.888 2.03 1.984 2.03ZM12.926 79.816c1.095 0 1.984-.909 1.984-2.03 0-1.12-.889-2.029-1.984-2.029-1.096 0-1.985.909-1.985 2.03 0 1.12.889 2.029 1.985 2.029ZM84.139 79.816c1.096 0 1.984-.909 1.984-2.03 0-1.12-.888-2.029-1.984-2.029s-1.984.909-1.984 2.03c0 1.12.888 2.029 1.984 2.029ZM42.819 84.994v15.975M54.246 84.994v15.975",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.347 2.29 1.84 81.125c-.968 1.72.245 3.87 2.18 3.87h89.014c1.946 0 3.158-2.15 2.18-3.87L50.707 2.29a2.496 2.496 0 0 0-4.37 0h.01Z",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m45.438 55.333-.899-13.765c-.166-2.68-.254-4.61-.254-5.779 0-1.59.41-2.829 1.222-3.719.811-.89 1.886-1.34 3.216-1.34 1.613 0 2.688.57 3.236 1.71.547 1.14.81 2.78.81 4.929 0 1.27-.068 2.549-.195 3.849l-1.212 14.175c-.127 1.69-.41 2.98-.84 3.879-.43.9-1.144 1.35-2.141 1.35-.997 0-1.711-.44-2.112-1.31-.4-.87-.674-2.2-.84-3.979h.01Zm3.119 18.915c-1.144 0-2.141-.38-2.992-1.14-.85-.76-1.28-1.82-1.28-3.18 0-1.189.41-2.199 1.222-3.028.811-.83 1.808-1.25 2.991-1.25s2.19.42 3.02 1.25c.831.83 1.252 1.84 1.252 3.029 0 1.34-.42 2.399-1.261 3.159-.84.76-1.828 1.15-2.952 1.15v.01Z",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgError;